export default {
  props: {
    tooltip: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    tooltipClass() {
      return { "has-tooltip": !!this.tooltip };
    },
  },
};
